import {
  DUPLICATE_ORDER_MESSAGE,
  DUPLICATE_ORDER_TITLE,
} from '../../constants/errors';

export const EMPTY_STATE_CONTENT = {
  title: 'No FIO Handles',
  message: 'There are no FIO Handles in all your wallets',
};

export const WARNING_CONTENT = {
  LOW_BUNDLES: {
    title: 'Low Bundles',
    message:
      'Low Bundles - Your remaining bundles amount is low, please add more bundles.',
  },
  EXPIRED_DOMAINS: {
    title: 'FIO Handle Domain(s) Expired',
    message:
      'One or more FIO Handle Domain has expired. Certain FIO Handle actions are inactive until the domain is renewed. Renew today to restore the actions.',
  },
  TOO_LONG_DOMAIN_RENEWAL: {
    title: 'FIO Domain Renewal Limit Exceeded',
    message:
      'Currently renewal can only extend up to the year 2100. Please adjust your renewal period to end on or before that date.',
  },
  DUPLICATE_ORDER: {
    title: DUPLICATE_ORDER_TITLE,
    message: DUPLICATE_ORDER_MESSAGE,
  },
};
